var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarnigcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.441,
    height: 13.334,
    viewBox: "0 0 32.441 13.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-linecap:round;}.a{stroke:#a0a7bb;stroke-width:1.5px;}.c,.d{stroke:none;}.d{fill:#a0a7bb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-163.829 -287.447)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.319)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.941,12.769,1.681,17.98l5.259,5.293",
    transform: "translate(162.89 276.447)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.941,12.769,1.681,17.98l5.259,5.293",
    transform: "translate(196.572 312.49) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(172.89 287.447)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.634,1.5a1,1,0,0,1,1.732,0l5.769,10a1,1,0,0,1-.866,1.5H1.731a1,1,0,0,1-.866-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 7.499999046325684 3.001655578613281 L 2.597105979919434 11.49999618530273 L 12.40288829803467 11.49999618530273 L 7.499999046325684 3.001655578613281 M 7.5 1.001112937927246 C 7.836887359619141 1.001112937927246 8.173774719238281 1.16787052154541 8.366189956665039 1.501385688781738 L 14.13477993011475 11.50027561187744 C 14.51939010620117 12.1669454574585 14.03824996948242 12.99999618530273 13.26858997344971 12.99999618530273 L 1.731410026550293 12.99999618530273 C 0.9617500305175781 12.99999618530273 0.4806098937988281 12.1669454574585 0.8652200698852539 11.50027561187744 L 6.633810043334961 1.501385688781738 C 6.826225280761719 1.16787052154541 7.163112640380859 1.001112937927246 7.5 1.001112937927246 Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 4,
    transform: "translate(180.39 292.947)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnigcode);
export default __webpack_public_path__ + "static/media/warnigcode.52b5821752b8234137d6174b4d6a51a0.svg";
export { ForwardRef as ReactComponent };